module.exports = __webpack_public_path__ + "static/media/snib-normal.db0fd977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/aliens/snib-normal.png
// module id = 155
// module chunks = 0